var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarviewicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 1.16406V3.4974",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#70707D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 1.16406V3.4974",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#70707D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91667 2.33594H11.0833C11.7277 2.33594 12.25 2.85827 12.25 3.5026V11.6693C12.25 12.3136 11.7277 12.8359 11.0833 12.8359H2.91667C2.27233 12.8359 1.75 12.3136 1.75 11.6693V3.5026C1.75 2.85827 2.27233 2.33594 2.91667 2.33594Z",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#70707D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 5.83594H12.25",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#70707D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 8.16406H4.67283",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#70707D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.16406H7.00583",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#70707D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 8.16406H9.33884",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#70707D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 10.5H4.67283",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#70707D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.5H7.00583",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#70707D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 10.5H9.33884",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#70707D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarviewicon);
export default __webpack_public_path__ + "static/media/calendarviewicon.41716c1a9078f565e5017660768088c8.svg";
export { ForwardRef as ReactComponent };